import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import ContextualString from '../../../../../../../../components/contextual/ContextualString';
import flyerPrintTemplateStrings from './contextualStrings';
import { getAsset } from '../../../../../../../../util/assets';
import useComponentSize from '../../../../../../../../hooks/useComponentSize';
import { getUtmParamsForQrCodeUrl } from '../helpers';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    organization_name: PropTypes.string.isRequired,
  }).isRequired,
};

const FlyerPrintTemplateSBJoinCode = ({ albumFolder, account }) => {
  const templateRef = useRef(null);
  const { width } = useComponentSize(templateRef);

  return (
    <Fragment>
      <p className="marketing-material-flyer-main-copy">
        <strong>{account.organization_name}</strong>{' '}
        <ContextualString
          id="shutterbugMainCopy"
          defaultMessage="is excited to announce that you’ll be able to view, download, and share all your favorite photos through our Waldo Photos gallery!"
          type={albumFolder.album_type}
          subtype={albumFolder.album_subtype}
          strings={flyerPrintTemplateStrings}
          values={{
            orgName: account.organization_name,
          }}
        />
      </p>

      <p className="marketing-material-flyer-target-secondary-copy text-uppercase">
        {albumFolder.join_code}
      </p>

      <div className="marketing-material-flyer-qrcode-main">
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({
            url: albumFolder.onboarding_short_url,
            albumFolder,
          })}
          size={width * 0.21 ?? 500}
        />
      </div>

      <p className="marketing-material-flyer-target-copy text-uppercase">
        <a href={albumFolder.onboarding_short_url}>{albumFolder.join_code}</a>
      </p>

      <img
        ref={templateRef}
        src={getAsset(
          '/marketing-material/MARKETING_FLYER_SB_JOIN_CODE_NEW.png',
        )}
        alt=""
      />
    </Fragment>
  );
};

FlyerPrintTemplateSBJoinCode.propTypes = propTypes;

export default FlyerPrintTemplateSBJoinCode;
